export default __webpack_public_path__ + "static/media/profile-picture.e2e50666.png";